export const getNumber = () => {
  // NOTE: `/products/` を削除した値
  return location.pathname.substring(10);
};
